$('input').popup({on: 'focus'}); // Active les Tooltips
// Fonction permettant de fermer les cross sur semantic ui
$('.message .close').on('click', function () {
    $(this).closest('.message').transition('fade');
});
$(document).ready(function () {
  $("img").unveil();
});
